import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { GenericLink } from '@core/models/types/generic-link.type';

@Component({
  selector: 'app-internal-links',
  templateUrl: './internal-links.component.html',
  styleUrls: ['./internal-links.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class InternalLinksComponent {
  @Input() list: GenericLink[] = [];

  constructor(private router: Router) {}

  redirectTo(item: GenericLink) {
    this.router.navigate([`${item.url}`]);
  }
}
